export { AlgoliaSearch } from "./AlgoliaSearch";
export { useSearch } from "src/hooks/useSearch";
